import { render, staticRenderFns } from "./urbanBigDataList.vue?vue&type=template&id=cf526a30&"
import script from "./urbanBigDataList.vue?vue&type=script&lang=js&"
export * from "./urbanBigDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports